import { useSelector } from "react-redux";
import MessageFrame from "../../MessageFrame/MessageFrame";
import { extractMessageHtml } from "../../../Actions/utils";
import { messageBodiesDataId } from "../../../Actions/getMessageBody";

// Renders a Teams message body (HTML) inside the shared auto-resizing iframe.
// When `showFull` is set and the full original body has been fetched into the
// warehouse (keyed by messageId), that complete body is rendered instead of the
// simplified one that arrives with the message listing.
const MessageBody = ({ title, body, messageId, showFull, maxHeight = "40vh" }) => {
  const fullBody = useSelector(
    (state) => state.warehouse.storage[messageBodiesDataId]?.[messageId]
  );

  const useFull = showFull && fullBody && !fullBody.empty;
  const html = extractMessageHtml(useFull ? fullBody : body);
  return <MessageFrame title={title} html={html} maxHeight={maxHeight} />;
};

export default MessageBody;
